import { Collection, } from "@bluelibs/x-ui";
import { Company } from "@root/api.types";
import { UsersCollection } from "@bundles/UIAppBundle/collections";
export class CompaniesCollection extends Collection {
    getName() {
        return "Companies";
    }
    getInputs() {
        return {
            insert: "CompanyInsertInput!",
            update: "CompanyUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => UsersCollection,
                name: "allowedUsers",
                many: true,
                field: "allowedUsersIds",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
